import { render, staticRenderFns } from "./ChestThoracic.vue?vue&type=template&id=3704c4ce&scoped=true"
import script from "./ChestThoracic.vue?vue&type=script&lang=js"
export * from "./ChestThoracic.vue?vue&type=script&lang=js"
import style0 from "./ChestThoracic.vue?vue&type=style&index=0&id=3704c4ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3704c4ce",
  null
  
)

export default component.exports